document.addEventListener('DOMContentLoaded', function() {
  const tabBtns = document.querySelectorAll('.f-tab-btn');
  const tabPanes = document.querySelectorAll('.f-tab-pane');

  if (tabBtns.length === 0) return;

  tabBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      // Remove active class from all
      tabBtns.forEach(b => b.classList.remove('active'));
      tabPanes.forEach(p => p.classList.remove('active'));

      // Add active class to clicked
      this.classList.add('active');
      const targetId = this.getAttribute('data-target');
      document.getElementById(targetId).classList.add('active');
    });
  });
});
